import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import TraficLight from '../components/traficLight'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'
import CustomizeAll from '../components/сustomize-all/'

// import CrmApplication from '../components/crm-application/'
import Slide from '@material-ui/core/Slide'
import Dialog from '@material-ui/core/Dialog'
import CrmApplicationForm from '../components/app-form/CrmApplicationForm'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Wrapper from '../components/wrapper'
import LicenseExpired from '../components/payment/LicenseExpired'
import { ActionsForUsing } from '../components/payment/LicenseExpired'
import {
  ButtonContained,
  ButtonOutlined,
} from '../components/app-button/button'

import {
  AmoCrmBigIcon,
  Bitrix24BigIcon,
  BitrixBigIcon,
  RetailCrmBigIcon,
  EnvyCrmBigIcon,
  UonCrmBigIcon,
  CustomCrmBigIcon,
  AccountIdentifierIcon,
  AccountAlertIcon,
  Pencile,
  MegaplanIcon,
  GetCourseBigIcon,
} from '../components/app-icon/Icons'

function Transition(props) {
  return <Slide direction="left" {...props} />
}

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginBottom: 32,
  },
  wizardContent: {
    maxWidth: 940,
    width: '100%',
  },
  crmsList: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  header: {
    padding: '15px 40px 6px 22px',
  },
  content: {
    padding: '16px 40px 30px 22px',
  },
  viewList: {
    margin: 0,
    padding: 0,
  },

  list: {
    padding: 0,
    listStyleType: 'none',
  },
  item: {
    marginBottom: 12,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(136, 102, 255)',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  icon: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: 'rgb(255, 204, 0)',
    borderRadius: '100%',
    marginRight: 15,
  },
  chanelList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  chanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '13px 15px 13px 32px',
  },
  chanelInfo: {
    listStyleType: 'none',
    padding: 0,
    marginLeft: 8,
    marginRight: 65,
    flex: 1,
  },
  chanelTitle: {
    fontFamily: 'Roboto',
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.75)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    lineHeight: 1.6,
    color: 'rgba(0, 0, 0, 0.5)',
  },
  chanelStatusIcon: {
    width: 16,
    height: 16,
    minWidth: '16px',
  },

  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    [theme.breakpoints.up('md')]: {},
    '@media (min-width:960px)': {
      // eslint-disable-line no-useless-computed-key
      paddingLeft: theme.spacing.unit * 8,
      paddingRight: theme.spacing.unit * 8,
    },
  },
  link: {
    textDecoration: 'none',
  },
  toolbarInner: {
    padding: 0,
  },
  extendedIcon: {
    marginRight: 5,
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 32,
    background: '#fff',
    borderRadius: 32,
  },
  info: {
    margin: 0,
    padding: 0,
    flex: 1,
  },
  siteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    margin: '0 19px 0 23px',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: '100%',
    backgroundColor: 'rgb(44, 50, 157)',
  },
  list: {
    margin: '0 0 16px 0',
    padding: '7px 20px 10px 40px',
    listStyleType: 'none',
    borderRadius: 4,
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  avatar: { width: 22, height: 22, marginRight: 10 },
  item: {
    position: 'relative',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .75)',
    '&::before': {
      content: '"↳"',
      marginRight: 5,
    },
  },
  dataIcon: {
    width: 16,
    height: 16,
    fill: 'rgba(0, 0, 0, .5)',
  },
  gaSymbol: {
    width: 36,
    height: 36,
  },
  chanelError: {
    backgroundColor: 'rgba(255, 59, 48, 0.1)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .5)',
  },
  chanelStatusError: {
    color: 'rgb(255, 59, 48)',
  },
  '@keyframes greyPulse': {
    '0%': {
      backgroundColor: 'grey',
    },
    '50%': {
      backgroundColor: '#BBB',
    },
    '100%': {
      backgroundColor: 'grey',
    },
  },
  '@keyframes trianglePulse': {
    '0%': {
      borderColor: 'grey transparent transparent transparent',
    },
    '50%': {
      borderColor: '#BBB transparent transparent transparent',
    },
    '100%': {
      borderColor: 'grey transparent transparent transparent',
    },
  },
  tooltip: {
    position: 'absolute',
    whiteSpace: 'pre-line',
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: 4,
    fontSize: 14,
    padding: '5px 8px',
    top: -22,
    left: 24,
    zIndex: 10,
    animationName: 'greyPulse',
    animationIterationCount: 'infinite',
    animationDuration: '1.4s',
    '&::after': {
      content: '" "',
      position: 'absolute',
      bottom: 0,
      left: 31,
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '7px 5px 0 5px',
      borderColor: '#000000 transparent transparent transparent',
      transform: 'translateY(100%)',
      animationName: 'trianglePulse',
      animationIterationCount: 'infinite',
      animationDuration: '1.4s',
    },
  },

  crmList: {
    paddingTop: '20px',
  },
  crmWrapper: {
    paddingTop: '10px',
  },
  crmBlock: {
    marginTop: '16px',
    width: '350px',
    borderRadius: '16px',
    boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#ffffff',
    padding: '16px 14px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '14px',
  },
  existedCrmBlock: {
    marginTop: '16px',
    width: '350px',
    borderRadius: '16px',
    boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#ffffff',
    padding: '16px 14px',
    position: 'relative',
  },
  crmButton: {
    width: '126px',
    height: '32px',
    lineHeight: '32px',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'center',
    borderRadius: '4px',
    backgroundColor: '#ffcc00',
    outline: 'none',
    textDecoration: 'none',
    color: '#000',
  },
  crmButtonNew: {
    width: '126px',
    height: '32px',
    lineHeight: '32px',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'center',
    borderRadius: '4px',
    border: 'solid 1px #8866ff',
    backgroundColor: '#fff',
    outline: 'none',
    textDecoration: 'none',
    color: '#000',
  },
  newCrm: {
    width: '188px',
  },
  crmStatisticBlock: {
    marginTop: '10px',
  },
  crmStatisticWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginTop: '10px',
  },
  crmDescription: {
    opacity: '0.75',
    fontSize: '12px',
    marginTop: 8,
  },
  crmsWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  statisticData: {
    opacity: '0.5',
    fontFamily: 'Roboto',
    fontSize: '10px',
    wordBreak: 'break-all',
  },
  statisticTitle: {
    opacity: '0.75',
    fontFamily: 'Roboto',
    fontSize: '14px',
  },
  errors: {
    color: '#ff3b30',
    fontFamily: 'Roboto',
    fontSize: '10px',
  },

  action: {
    fontSize: 14,
    fontWeight: 500,
    color: 'rgb(0, 0, 0)',
    whiteSpace: 'pre-line',
  },
  icon: {
    marginRight: 16,
  },
  description: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    padding: 16,
    cursor: 'pointer',
  },

  appBar: {
    position: 'relative',
  },
  paper: { backgroundColor: '#ffcc00' },
  modalTitle: {
    marginBottom: 24,
    textAlign: 'center',
  },
  modalIcon: {
    marginBottom: 16,
  },
  subTitle: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'rgb(0, 0, 0)',
    whiteSpace: 'pre-line',
  },
  penile: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  noLeads: {
    marginTop: '15px',
    opacity: '0.75',
    fontFamily: 'Roboto',
    fontSize: '13px',
  },
})

class Crm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      site: window.state.site,
      openModal: false,
      openSnakbar: false,
      fetching: {
        bitrix24: false,
        bitrix: false,
        retail: false,
      },
      crmApplications: state.crmApplications,
      isEditedStatistics: window.state.hasEditedStatistics,
      isActiveDataSources: window.state.hasActiveDataSources,
      user: window.state.user,
    }
  }

  handleReload = event => {
    event.preventDefault()

    window.location.reload()

    return false
  }

  successData = status => {
    if (status === 'ok') {
      this.timer = setTimeout(
        () =>
          this.setState({
            openModal: false,
            isFetching: false,
            openSnakbar: true,
          }),
        600
      )
    }
  }

  handleClickOpen = event => {
    event.preventDefault()
    this.setState({ openModal: true })
  }

  handleClose = () => {
    this.setState({ openModal: false, isFetching: false })
  }

  handleCloseSnakbar = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.setState({ openSnakbar: false })
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = '/crm/create'

    const options = values => ({
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }

      this.setState({
        isFetching: false,
      })
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options(values))
      .then(handleResponse)
      .then(({ status }) => {
        this.successData(status)
      })
      .catch(errors)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  handleNewCrm(e, crm) {
    crm = crm || ''

    let fetching = this.state.fetching
    fetching[crm] = true
    this.setState({ fetching: fetching })

    let data = {
      crm_name: crm,
      description: '',
    }

    const url = '/crm/create'

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(data),
    })
      .then(status)
      .then(json)
      .then(data => {
        let crmApplications = this.state.crmApplications
        crmApplications[crm] = true

        let fetching = this.state.fetching
        fetching[crm] = true

        this.setState({
          fetching: fetching,
          crmApplications: crmApplications,
        })
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })

    e.preventDefault()
  }

  render() {
    const { classes } = this.props
    const { openModal, openSnakbar, site, user } = this.state

    const getAmoStatusesWithPipelinesString = () => {
      if (!window.state.amoCrm) {
        return false
      }

      const account = window.state.amoCrm.settings

      if (!account.pipelines) {
        return '[?]'
      }

      let statuses = []

      for (var i in account.pipelines) {
        var pip = account.pipelines[i]

        if (!pip.statuses) {
          continue
        }

        for (var j in pip.statuses) {
          statuses.push(pip.statuses[j].name + ' (воронка "' + pip.name + '")')
        }
      }

      if (!statuses.length) {
        return '[?]'
      }

      if (statuses.length > 3) {
        return statuses.slice(0, 3).join(', ') + ' и другие'
      }

      return statuses.join(', ')
    }

    return (
      <Fragment>
        {user.wizard_finished_at && (
          <LicenseExpired>
            <ActionsForUsing />
          </LicenseExpired>
        )}
        <div className={classes.pageTemplate}>
          <AppBar
            position="static"
            color="inherit"
            elevation={0}
            style={{ padding: '24px' }}
          >
            <Toolbar className={classes.toolbarInner}>
              <LogoData />

              <a
                className={classes.container}
                href={`http://${site.url.replace(/(http|https):\/\//is, '')}`}
                target="_blank"
              >
                <div className={classes.siteIcon}>S</div>
                <ul className={classes.info}>
                  <Typography component="li" variant="body1">
                    {site.url}
                  </Typography>
                  <Typography component="li" variant="overline">
                    {site.name}
                  </Typography>
                </ul>
              </a>

              {user.wizard_finished_at && <TraficLight />}
            </Toolbar>
          </AppBar>

          <CustomizeAll />

          <div className={classes.wizardRow}>
            <LeftNavigationDashboard />

            <div className={classes.wizardContent}>
              <p>
                Экспорт данных об офлайн покупках (статус "Успешная продажа") из
                CRM в Google Analytics
              </p>
              <div className={classes.crmsList}>
                {state.amoCrm.settings ||
                state.bitrix24.settings ||
                state.retailCrm.settings ||
                state.bitrix.settings ||
                state.envyCrm.settings ||
                state.uon.settings ||
                state.custom.settings ? (
                  <div className={classes.crmsWrapper}>
                    {state.amoCrm.settings ? (
                      <a
                        href="/crm/amo"
                        style={{
                          color: '#000',
                        }}
                      >
                        <div>
                          <div className={classes.crmWrapper}>
                            {state.amoCrm.settings ? (
                              <div className={classes.existedCrmBlock}>
                                <Pencile className={classes.penile} />
                                <AmoCrmBigIcon width={100} height={22} />
                                <div className={classes.crmDescription}>
                                  В Google Analytics из CRM передаются данные о
                                  сделках, перешедших в статус "Успешно
                                  реализована"
                                </div>
                                <div className={classes.crmStatisticBlock}>
                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        {state.amoCrm.settings.subdomain}
                                        .amocrm.com
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.amoCrm.settings.login}
                                        <br />
                                        API ключ: {state.amoCrm.settings.hash}
                                      </div>
                                      {state.amoCrm.isAvailable ? (
                                        ''
                                      ) : (
                                        <div className={classes.errors}>
                                          Ошибка поключения а аккаунту.
                                          Проверьте правильность введенных
                                          учетных данный
                                        </div>
                                      )}
                                    </div>
                                    {state.amoCrm.isAvailable ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <AccountAlertIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    )}
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Поле CID
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.amoCrm.settings &&
                                        state.amoCrm.settings.field != null
                                          ? state.amoCrm.settings.field
                                          : ''}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Куда отправлять данные
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.amoCrm.settings &&
                                        state.amoCrm.settings
                                          .import_destination == 'ecom'
                                          ? 'Покупки в электронной торговле'
                                          : ''}

                                        {state.amoCrm.settings &&
                                        state.amoCrm.settings
                                          .import_destination == 'event'
                                          ? 'Создать цель "Успешные продажи"'
                                          : ''}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Выбранные статусы сделок
                                      </div>
                                      <div className={classes.statisticData}>
                                        {getAmoStatusesWithPipelinesString()}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Последняя отправка данных
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.amoCrm.data &&
                                        (!state.amoCrm.error ||
                                          !state.amoCrm.error.text)
                                          ? state.amoCrm.data.updated_at
                                          : ''}
                                      </div>
                                      {state.amoCrm.error &&
                                      state.amoCrm.error.text ? (
                                        <div className={classes.errors}>
                                          {state.amoCrm.error.text}
                                          {state.amoCrm.error.date ? (
                                            <span>
                                              <br />
                                              Данные не выгружаются с:{' '}
                                              {state.amoCrm.error.date}
                                            </span>
                                          ) : (
                                            <div>
                                              <br />
                                              Нет данных
                                            </div>
                                          )}
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                      {!state.amoCrm.data &&
                                      (!state.amoCrm.error ||
                                        !state.amoCrm.error.text) ? (
                                        <div className={classes.statisticData}>
                                          Данные по продажам пока не поступали
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                    {state.amoCrm.data &&
                                    (!state.amoCrm.error ||
                                      !state.amoCrm.error.text) ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <div>
                                        {state.amoCrm.error ? (
                                          <AccountAlertIcon
                                            className={classes.chanelStatusIcon}
                                          />
                                        ) : null}
                                      </div>
                                    )}
                                  </div>
                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Передача client_id
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.amoCrm.cid
                                          ? 'Все в порядке.'
                                          : ''}
                                      </div>
                                      {state.amoCrm.cid ? (
                                        ''
                                      ) : (
                                        <div>
                                          {!state.amoCrm.data ? (
                                            <div
                                              className={classes.statisticData}
                                            >
                                              Данные по продажам пока не
                                              поступали
                                            </div>
                                          ) : (
                                            <div className={classes.errors}>
                                              client_id не найден
                                              <br />
                                              Убедитесь, что{' '}
                                              <a
                                                href="https://www.amocrm.ru/support/field/create_a_field"
                                                target="_blank"
                                              >
                                                создано
                                              </a>{' '}
                                              дополнительное поле "cid" в
                                              сущности "Контакт" и оно
                                              заполнено. Это поле должно
                                              содержать client_id пользователя
                                              из Google Analytics.
                                              <br />
                                            </div>
                                          )}
                                        </div>
                                      )}
                                      {!state.amoCrm.haveLead ? (
                                        <div className={classes.noLeads}>
                                          <div>
                                            Пожалуйста, создайте тестовую сделку
                                            и переведите ее в любой из статусов
                                            выбранных статусов сделок. Проверка
                                            пройдет в течение одной минуты.
                                          </div>
                                          <ButtonOutlined
                                            handleClick={this.handleReload}
                                            style={{
                                              width: '100%',
                                              height: 48,
                                              padding: 0,
                                              marginTop: 16
                                            }}
                                            color="secondary"
                                            text="Проверить тестовый заказ"
                                          />
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                    {state.amoCrm.cid ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <div>
                                        {!state.amoCrm.data ? (
                                          ''
                                        ) : (
                                          <AccountAlertIcon
                                            className={classes.chanelStatusIcon}
                                          />
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      </a>
                    ) : (
                      ''
                    )}

                    {state.bitrix24.settings ? (
                      <a
                        href="/crm/bitrix24"
                        style={{
                          color: '#000',
                        }}
                      >
                        <div>
                          <div className={classes.crmWrapper}>
                            {state.bitrix24.settings ? (
                              <div className={classes.existedCrmBlock}>
                                <Pencile className={classes.penile} />
                                <Bitrix24BigIcon width={100} height={22} />
                                <div className={classes.crmDescription}>
                                  В Google Analytics из CRM передаются данные о
                                  сделках, перешедших в статус "Сделка успешна"
                                </div>
                                <div className={classes.crmStatisticBlock}>
                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        {state.bitrix24.settings.endpoint
                                          .length > 45 ? (
                                          <div>
                                            {state.bitrix24.settings.endpoint.slice(
                                              0,
                                              43
                                            )}
                                            ...
                                          </div>
                                        ) : (
                                          <div>
                                            {state.bitrix24.settings.endpoint}
                                          </div>
                                        )}
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.bitrix24.settings.auth_code}
                                        {/* <br />
                                    hash: {state.amoCrm.settings.hash} */}
                                      </div>
                                      {state.bitrix24.isAvailable ? (
                                        ''
                                      ) : (
                                        <div className={classes.errors}>
                                          Ошибка поключения а аккаунту.
                                          Проверьте правильность введенных
                                          учетных данный
                                        </div>
                                      )}
                                    </div>
                                    {state.bitrix24.isAvailable ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <AccountAlertIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    )}
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Куда отправлять данные
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.bitrix24.settings &&
                                        state.bitrix24.settings
                                          .import_destination == 'ecom'
                                          ? 'Покупки в электронной торговле'
                                          : ''}

                                        {state.bitrix24.settings &&
                                        state.bitrix24.settings
                                          .import_destination == 'event'
                                          ? 'Создать цель "Успешные продажи"'
                                          : ''}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Поле CID
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.bitrix24.settings &&
                                        state.bitrix24.settings.field != null
                                          ? state.bitrix24.settings.field
                                          : ''}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Выбранные статусы сделок
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.bitrix24.statuses &&
                                          state.bitrix24.statuses.map(
                                            source => {
                                              return source + ' '
                                            }
                                          )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Последняя отправка данных
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.bitrix24.data &&
                                        (!state.bitrix24.error ||
                                          !state.bitrix24.error.text)
                                          ? state.bitrix24.data.updated_at
                                          : ''}
                                      </div>
                                      {state.bitrix24.error &&
                                      state.bitrix24.error.text ? (
                                        <div className={classes.errors}>
                                          {state.bitrix24.error.text}
                                          {state.bitrix24.error.date ? (
                                            <span>
                                              <br />
                                              Данные не выгружаются с:{' '}
                                              {state.bitrix24.error.date}
                                            </span>
                                          ) : (
                                            <div>
                                              <br />
                                              Нет данных
                                            </div>
                                          )}
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                      {!state.bitrix24.data &&
                                      (!state.bitrix24.error ||
                                        !state.bitrix24.error.text) ? (
                                        <div className={classes.statisticData}>
                                          Данные по продажам пока не поступали
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                    {state.bitrix24.data &&
                                    (!state.bitrix24.error ||
                                      !state.bitrix24.error.text) ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <div>
                                        {state.bitrix24.error ? (
                                          <AccountAlertIcon
                                            className={classes.chanelStatusIcon}
                                          />
                                        ) : null}
                                      </div>
                                    )}
                                  </div>
                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Передача client_id
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.bitrix24.cid
                                          ? 'Все в порядке.'
                                          : ''}
                                      </div>
                                      {state.bitrix24.cid ? (
                                        ''
                                      ) : (
                                        <div>
                                          {!state.bitrix24.data ? (
                                            <div
                                              className={classes.statisticData}
                                            >
                                              Данные по продажам пока не
                                              поступали
                                            </div>
                                          ) : (
                                            <div className={classes.errors}>
                                              client_id не найден
                                              <br />
                                              Убедитесь, что создано
                                              дополнительное поле "cid" и оно
                                              заполнено. Это поле должно
                                              содержать client_id пользователя
                                              из Google Analytics.
                                              <br />
                                            </div>
                                          )}
                                        </div>
                                      )}
                                      {!state.bitrix24.haveLead ? (
                                        <div className={classes.noLeads}>
                                          {state.bitrix24.statuses &&
                                          state.bitrix24.statuses.length > 1 ? (
                                            <div>
                                              Пожалуйста, создайте тестовую
                                              сделку и переведите ее в любой из
                                              статусов{' '}
                                              {'{' +
                                                state.bitrix24.statuses +
                                                '}'}
                                              . Проверка пройдет в течение одной
                                              минуты.
                                            </div>
                                          ) : (
                                            <div>
                                              Пожалуйста, создайте тестовую
                                              сделку и переведите ее статус{' '}
                                              {'{' +
                                                state.bitrix24.statuses +
                                                '}'}
                                              . Проверка пройдет в течение одной
                                              минуты.
                                            </div>
                                          )}
                                          <ButtonOutlined
                                            handleClick={this.handleReload}
                                            style={{
                                              width: '100%',
                                              height: 48,
                                              padding: 0,
                                              marginTop: 16
                                            }}
                                            color="secondary"
                                            text="Проверить тестовый заказ"
                                          />
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                    {state.bitrix24.cid ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <div>
                                        {!state.bitrix24.data ? (
                                          ''
                                        ) : (
                                          <AccountAlertIcon
                                            className={classes.chanelStatusIcon}
                                          />
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      </a>
                    ) : (
                      ''
                    )}

                    {state.megaplan.settings ? (
                      <a
                        href="/crm/megaplan"
                        style={{
                          color: '#000',
                        }}
                      >
                        <div>
                          <div className={classes.crmWrapper}>
                            {state.megaplan.settings ? (
                              <div className={classes.existedCrmBlock}>
                                <Pencile className={classes.penile} />
                                <MegaplanIcon height={20} />
                                <div className={classes.crmDescription}>
                                  В Google Analytics из CRM передаются данные о
                                  сделках, перешедших в статус "Сделка успешна"
                                </div>
                                <div className={classes.crmStatisticBlock}>
                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        {state.megaplan.settings.url.length >
                                        45 ? (
                                          <div>
                                            {state.megaplan.settings.url}...
                                          </div>
                                        ) : (
                                          <div>
                                            {state.megaplan.settings.url}
                                          </div>
                                        )}
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.megaplan.settings.auth_code}
                                        {/* <br />
                                    hash: {state.amoCrm.settings.hash} */}
                                      </div>
                                      {state.megaplan.isAvailable ? (
                                        ''
                                      ) : (
                                        <div className={classes.errors}>
                                          Ошибка поключения а аккаунту.
                                          Проверьте правильность введенных
                                          учетных данный
                                        </div>
                                      )}
                                    </div>
                                    {state.megaplan.isAvailable ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <AccountAlertIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    )}
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Куда отправлять данные
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.megaplan.settings &&
                                        state.megaplan.settings
                                          .import_destination == 'ecom'
                                          ? 'Покупки в электронной торговле'
                                          : ''}

                                        {state.megaplan.settings &&
                                        state.megaplan.settings
                                          .import_destination == 'event'
                                          ? 'Создать цель "Успешные продажи"'
                                          : ''}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Выбранные статусы сделок
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.megaplan.statuses &&
                                          state.megaplan.statuses.map(
                                            source => {
                                              return source + ' '
                                            }
                                          )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Последняя отправка данных
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.megaplan.data &&
                                        (!state.megaplan.error ||
                                          !state.megaplan.error.text)
                                          ? state.megaplan.data.updated_at
                                          : ''}
                                      </div>
                                      {state.megaplan.error &&
                                      state.megaplan.error.text ? (
                                        <div className={classes.errors}>
                                          {state.megaplan.error.text}
                                          {state.megaplan.error.date ? (
                                            <span>
                                              <br />
                                              Данные не выгружаются с:{' '}
                                              {state.megaplan.error.date}
                                            </span>
                                          ) : (
                                            <div>
                                              <br />
                                              Нет данных
                                            </div>
                                          )}
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                      {!state.megaplan.data &&
                                      (!state.megaplan.error ||
                                        !state.megaplan.error.text) ? (
                                        <div className={classes.statisticData}>
                                          Данные по продажам пока не поступали
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                    {state.megaplan.data &&
                                    (!state.megaplan.error ||
                                      !state.megaplan.error.text) ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <div>
                                        {state.megaplan.error ? (
                                          <AccountAlertIcon
                                            className={classes.chanelStatusIcon}
                                          />
                                        ) : null}
                                      </div>
                                    )}
                                  </div>
                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Передача client_id
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.megaplan.cid
                                          ? 'Все в порядке.'
                                          : ''}
                                      </div>
                                      {state.megaplan.cid ? (
                                        ''
                                      ) : (
                                        <div>
                                          {!state.megaplan.data ? (
                                            <div
                                              className={classes.statisticData}
                                            >
                                              Данные по продажам пока не
                                              поступали
                                            </div>
                                          ) : (
                                            <div className={classes.errors}>
                                              client_id не найден
                                              <br />
                                              Убедитесь, что создано
                                              дополнительное поле "cid" и оно
                                              заполнено. Это поле должно
                                              содержать client_id пользователя
                                              из Google Analytics.
                                              <br />
                                            </div>
                                          )}
                                        </div>
                                      )}
                                      {!state.bitrix24.haveLead ? (
                                        <div className={classes.noLeads}>
                                          {state.megaplan.statuses &&
                                          state.megaplan.statuses.length > 1 ? (
                                            <div>
                                              Пожалуйста, создайте тестовую
                                              сделку и переведите ее в любой из
                                              статусов{' '}
                                              {'{' +
                                                state.megaplan.statuses +
                                                '}'}
                                              . Проверка пройдет в течение одной
                                              минуты.
                                            </div>
                                          ) : (
                                            <div>
                                              Пожалуйста, создайте тестовую
                                              сделку и переведите ее статус{' '}
                                              {'{' +
                                                state.megaplan.statuses +
                                                '}'}
                                              . Проверка пройдет в течение одной
                                              минуты.
                                            </div>
                                          )}
                                          <ButtonOutlined
                                            handleClick={this.handleReload}
                                            style={{
                                              width: '100%',
                                              height: 48,
                                              padding: 0,
                                              marginTop: 16
                                            }}
                                            color="secondary"
                                            text="Проверить тестовый заказ"
                                          />
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                    {state.megaplan.cid ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <div>
                                        {!state.megaplan.data ? (
                                          ''
                                        ) : (
                                          <AccountAlertIcon
                                            className={classes.chanelStatusIcon}
                                          />
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      </a>
                    ) : (
                      ''
                    )}

                    {state.retailCrm.settings ? (
                      <a
                        href="/crm/retail"
                        style={{
                          color: '#000',
                        }}
                      >
                        <div>
                          <div className={classes.crmWrapper}>
                            {state.retailCrm.settings ? (
                              <div className={classes.existedCrmBlock}>
                                <Pencile className={classes.penile} />
                                <RetailCrmBigIcon width={100} height={22} />
                                <div className={classes.crmDescription}>
                                  В Google Analytics из CRM передаются данные о
                                  заказах, перешедших в статус "Выполнен"
                                </div>
                                <div className={classes.crmStatisticBlock}>
                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        {state.retailCrm.settings.endpoint}
                                      </div>
                                      <div className={classes.statisticData}>
                                        code: {state.retailCrm.settings.code}
                                        <br />
                                        api key:{' '}
                                        {state.retailCrm.settings.api_key}
                                      </div>
                                      {state.retailCrm.isAvailable ? (
                                        ''
                                      ) : (
                                        <div className={classes.errors}>
                                          Ошибка поключения а аккаунту.
                                          Проверьте правильность введенных
                                          учетных данный
                                        </div>
                                      )}
                                    </div>
                                    {state.retailCrm.isAvailable ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <AccountAlertIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    )}
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Выбранные статусы сделок
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.retailCrm.statuses &&
                                          state.retailCrm.statuses.map(
                                            source => {
                                              return source + ' '
                                            }
                                          )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Статус возвратов
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.retailCrm.settings
                                          .cancel_status &&
                                        state.retailCrm.settings.cancel_status
                                          ? state.retailCrm.settings
                                              .cancel_status
                                          : '-'}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Поле CID
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.retailCrm.settings &&
                                        state.retailCrm.settings.field != null
                                          ? state.retailCrm.settings.field
                                          : ''}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Куда отправлять данные
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.retailCrm.settings &&
                                        state.retailCrm.settings
                                          .import_destination == 'ecom'
                                          ? 'Покупки в электронной торговле'
                                          : ''}

                                        {state.retailCrm.settings &&
                                        state.retailCrm.settings
                                          .import_destination == 'event'
                                          ? 'Создать цель "Успешные продажи"'
                                          : ''}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Последняя отправка данных
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.retailCrm.data &&
                                        (!state.retailCrm.error ||
                                          !state.retailCrm.error.text)
                                          ? state.retailCrm.data.updated_at
                                          : ''}
                                      </div>
                                      {state.retailCrm.error &&
                                      state.retailCrm.error.text ? (
                                        <div className={classes.errors}>
                                          {state.retailCrm.error.text}
                                          {state.retailCrm.error.date ? (
                                            <span>
                                              <br />
                                              Данные не выгружаются с:{' '}
                                              {
                                                state.retailCrm.error.date
                                                  .length
                                              }
                                            </span>
                                          ) : (
                                            <div>
                                              <br />
                                              Нет данных
                                            </div>
                                          )}
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                      {!state.retailCrm.data &&
                                      (!state.retailCrm.error ||
                                        !state.retailCrm.error.text) ? (
                                        <div className={classes.statisticData}>
                                          Данные по продажам пока не поступали
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                    {state.retailCrm.data &&
                                    (!state.retailCrm.error ||
                                      !state.retailCrm.error.text) ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <div>
                                        {state.retailCrm.error ? (
                                          <AccountAlertIcon
                                            className={classes.chanelStatusIcon}
                                          />
                                        ) : null}
                                      </div>
                                    )}
                                  </div>
                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Передача client_id
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.retailCrm.cid
                                          ? 'Все в порядке.'
                                          : ''}
                                      </div>
                                      {state.retailCrm.cid ? (
                                        ''
                                      ) : (
                                        <div>
                                          {!state.retailCrm.data ? (
                                            <div
                                              className={classes.statisticData}
                                            >
                                              Данные по продажам пока не
                                              поступали
                                            </div>
                                          ) : (
                                            <div className={classes.errors}>
                                              client_id не найден
                                              <br />
                                              Убедитесь, что создано
                                              дополнительное поле "cid" и оно
                                              заполнено. Это поле должно
                                              содержать client_id пользователя
                                              из Google Analytics.
                                              <br />
                                            </div>
                                          )}
                                        </div>
                                      )}
                                      {!state.retailCrm.haveLead ? (
                                        <div className={classes.noLeads}>
                                          {state.retailCrm.statuses &&
                                          state.retailCrm.statuses.length >
                                            1 ? (
                                            <div>
                                              Пожалуйста, создайте тестовую
                                              сделку и переведите ее в любой из
                                              статусов{' '}
                                              {'{' +
                                                state.retailCrm.statuses +
                                                '}'}
                                              . Проверка пройдет в течение одной
                                              минуты.
                                            </div>
                                          ) : (
                                            <div style={{marginTop: 16}}>
                                              Пожалуйста, создайте тестовую
                                              сделку и переведите ее статус{' '}
                                              {'{' +
                                                state.retailCrm.statuses +
                                                '}'}
                                              . Проверка пройдет в течение одной
                                              минуты.
                                            </div>
                                          )}
                                          <ButtonOutlined
                                            handleClick={this.handleReload}
                                            style={{
                                              width: '100%',
                                              height: 48,
                                              padding: 0,
                                              marginTop: 16
                                            }}
                                            color="secondary"
                                            text="Проверить тестовый заказ"
                                          />
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                    {state.retailCrm.cid ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <div>
                                        {!state.retailCrm.data ? (
                                          ''
                                        ) : (
                                          <AccountAlertIcon
                                            className={classes.chanelStatusIcon}
                                          />
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      </a>
                    ) : (
                      ''
                    )}

                    {state.envyCrm.settings ? (
                      <a
                        href="/crm/envy"
                        style={{
                          color: '#000',
                        }}
                      >
                        <div>
                          <div className={classes.crmWrapper}>
                            {state.envyCrm.settings ? (
                              <div className={classes.existedCrmBlock}>
                                <Pencile className={classes.penile} />
                                <EnvyCrmBigIcon height={22} />
                                <div className={classes.crmDescription}>
                                  В Google Analytics из CRM передаются данные о
                                  заказах, перешедших в статус "Выполнен"
                                </div>
                                <div className={classes.crmStatisticBlock}>
                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        {state.envyCrm.settings.endpoint}
                                      </div>
                                      <div className={classes.statisticData}>
                                        crm id: {state.envyCrm.settings.crm_id}
                                      </div>
                                      {state.envyCrm.isAvailable ? (
                                        ''
                                      ) : (
                                        <div className={classes.errors}>
                                          Ошибка поключения а аккаунту.
                                          Проверьте правильность введенных
                                          учетных данный
                                        </div>
                                      )}
                                    </div>
                                    {state.envyCrm.isAvailable ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <AccountAlertIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    )}
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Выбранные статусы сделок
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.envyCrm.statuses &&
                                          state.envyCrm.statuses.map(source => {
                                            return source + ' '
                                          })}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Поле CID
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.envyCrm.settings &&
                                        state.envyCrm.settings.field != null
                                          ? state.envyCrm.settings.field
                                          : ''}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Куда отправлять данные
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.envyCrm.settings &&
                                        state.envyCrm.settings
                                          .import_destination == 'ecom'
                                          ? 'Покупки в электронной торговле'
                                          : ''}

                                        {state.envyCrm.settings &&
                                        state.envyCrm.settings
                                          .import_destination == 'event'
                                          ? 'Создать цель "Успешные продажи"'
                                          : ''}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Последняя отправка данных
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.envyCrm.data &&
                                        (!state.envyCrm.error ||
                                          !state.envyCrm.error.text)
                                          ? state.envyCrm.data.updated_at
                                          : ''}
                                      </div>
                                      {state.envyCrm.error &&
                                      state.envyCrm.error.text ? (
                                        <div className={classes.errors}>
                                          {state.envyCrm.error.text}
                                          {state.envyCrm.error.date ? (
                                            <span>
                                              <br />
                                              Данные не выгружаются с:{' '}
                                              {state.envyCrm.error.date.length}
                                            </span>
                                          ) : (
                                            <div>
                                              <br />
                                              Нет данных
                                            </div>
                                          )}
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                      {!state.envyCrm.data &&
                                      (!state.envyCrm.error ||
                                        !state.envyCrm.error.text) ? (
                                        <div className={classes.statisticData}>
                                          Данные по продажам пока не поступали
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                    {state.envyCrm.data &&
                                    (!state.envyCrm.error ||
                                      !state.envyCrm.error.text) ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <div>
                                        {state.envyCrm.error ? (
                                          <AccountAlertIcon
                                            className={classes.chanelStatusIcon}
                                          />
                                        ) : null}
                                      </div>
                                    )}
                                  </div>
                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Передача client_id
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.envyCrm.cid
                                          ? 'Все в порядке.'
                                          : ''}
                                      </div>
                                      {state.envyCrm.cid ? (
                                        ''
                                      ) : (
                                        <div>
                                          {!state.envyCrm.data ? (
                                            <div
                                              className={classes.statisticData}
                                            >
                                              Данные по продажам пока не
                                              поступали
                                            </div>
                                          ) : (
                                            <div className={classes.errors}>
                                              client_id не найден
                                              <br />
                                              Убедитесь, что создано
                                              дополнительное поле "cid" и оно
                                              заполнено. Это поле должно
                                              содержать client_id пользователя
                                              из Google Analytics.
                                              <br />
                                            </div>
                                          )}
                                        </div>
                                      )}
                                      {!state.envyCrm.haveLead ? (
                                        <div className={classes.noLeads}>
                                          {state.envyCrm.statuses &&
                                          state.envyCrm.statuses.length > 1 ? (
                                            <div>
                                              Пожалуйста, создайте тестовую
                                              сделку и переведите ее в любой из
                                              статусов{' '}
                                              {'{' +
                                                state.envyCrm.statuses +
                                                '}'}
                                              . Проверка пройдет в течение одной
                                              минуты.
                                            </div>
                                          ) : (
                                            <div>
                                              Пожалуйста, создайте тестовую
                                              сделку и переведите ее статус{' '}
                                              {'{' +
                                                state.envyCrm.statuses +
                                                '}'}
                                              . Проверка пройдет в течение одной
                                              минуты.
                                            </div>
                                          )}
                                          <ButtonOutlined
                                            handleClick={this.handleReload}
                                            style={{
                                              width: '100%',
                                              height: 48,
                                              padding: 0,
                                              marginTop: 16
                                            }}
                                            color="secondary"
                                            text="Проверить тестовый заказ"
                                          />
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                    {state.envyCrm.cid ? (
                                      <AccountIdentifierIcon
                                        className={classes.chanelStatusIcon}
                                      />
                                    ) : (
                                      <div>
                                        {!state.envyCrm.data ? (
                                          ''
                                        ) : (
                                          <AccountAlertIcon
                                            className={classes.chanelStatusIcon}
                                          />
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      </a>
                    ) : (
                      ''
                    )}

                    {state.bitrix.settings ? (
                      <a
                        href="/crm/bitrix"
                        style={{
                          color: '#000',
                        }}
                      >
                        <div>
                          <div className={classes.crmWrapper}>
                            <div className={classes.existedCrmBlock}>
                              <Pencile className={classes.penile} />
                              <BitrixBigIcon width={100} height={22} />
                              <div className={classes.crmDescription}>
                                В Google Analytics из CMS передаются данные об
                                оплаченных заказах
                              </div>
                              <div className={classes.crmStatisticBlock}>
                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Код активации:{' '}
                                      {state.bitrix.settings.hash}
                                    </div>
                                    {state.bitrix.isAvailable ? (
                                      ''
                                    ) : (
                                      <div className={classes.errors}>
                                        Ошибка поключения а аккаунту. Проверьте
                                        правильность введенных учетных данный
                                      </div>
                                    )}
                                  </div>
                                  {state.bitrix.isAvailable ? (
                                    <AccountIdentifierIcon
                                      className={classes.chanelStatusIcon}
                                    />
                                  ) : (
                                    <AccountAlertIcon
                                      className={classes.chanelStatusIcon}
                                    />
                                  )}
                                </div>

                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Выбранные статусы сделок
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.bitrix.statuses &&
                                        state.bitrix.statuses.map(source => {
                                          return source + ' '
                                        })}
                                    </div>
                                  </div>
                                </div>

                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Поле CID
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.bitrix.settings &&
                                      state.bitrix.settings.field != null
                                        ? state.bitrix.settings.field
                                        : ''}
                                    </div>
                                  </div>
                                </div>

                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Куда отправлять данные
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.bitrix.settings &&
                                      state.bitrix.settings
                                        .import_destination == 'ecom'
                                        ? 'Покупки в электронной торговле'
                                        : ''}

                                      {state.bitrix.settings &&
                                      state.bitrix.settings
                                        .import_destination == 'event'
                                        ? 'Создать цель "Успешные продажи"'
                                        : ''}
                                    </div>
                                  </div>
                                </div>

                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Последняя отправка данных
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.bitrix.data &&
                                      (!state.bitrix.error ||
                                        !state.bitrix.error.text)
                                        ? state.bitrix.data.updated_at
                                        : ''}
                                    </div>
                                    {state.bitrix.error &&
                                    state.bitrix.error.text ? (
                                      <div className={classes.errors}>
                                        {state.bitrix.error.text}
                                        {state.bitrix.error.date ? (
                                          <span>
                                            <br />
                                            Данные не выгружаются с:{' '}
                                            {state.bitrix.error.date}
                                          </span>
                                        ) : (
                                          <div>
                                            <br />
                                            Нет данных
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                    {!state.bitrix.data &&
                                    (!state.bitrix.error ||
                                      !state.bitrix.error.text) ? (
                                      <div className={classes.statisticData}>
                                        Данные по продажам пока не поступали
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                  {state.bitrix.data &&
                                  (!state.bitrix.error ||
                                    !state.bitrix.error.text) ? (
                                    <AccountIdentifierIcon
                                      className={classes.chanelStatusIcon}
                                    />
                                  ) : (
                                    <div>
                                      {!state.bitrix.data ? (
                                        ''
                                      ) : (
                                        <AccountAlertIcon
                                          className={classes.chanelStatusIcon}
                                        />
                                      )}
                                    </div>
                                  )}
                                </div>
                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Передача client_id
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.bitrix.cid ? 'Все в порядке.' : ''}
                                    </div>
                                    {state.bitrix.cid ? (
                                      ''
                                    ) : (
                                      <div>
                                        {!state.bitrix.data ? (
                                          <div
                                            className={classes.statisticData}
                                          >
                                            Данные по продажам пока не поступали
                                          </div>
                                        ) : (
                                          <div className={classes.errors}>
                                            client_id не найден
                                            <br />
                                            Убедитесь, что создано
                                            дополнительное поле "cid" и оно
                                            заполнено. Это поле должно содержать
                                            client_id пользователя из Google
                                            Analytics.
                                            <br />
                                          </div>
                                        )}
                                      </div>
                                    )}
                                    {!state.bitrix.haveLead ? (
                                      <div className={classes.noLeads}>
                                        <div>
                                          Пожалуйста, создайте тестовую сделку и
                                          переведите ее статус {'{purchase}'}.
                                          Проверка пройдет в течение одной
                                          минуты.
                                        </div>
                                        <ButtonOutlined
                                          handleClick={this.handleReload}
                                          style={{
                                            width: '100%',
                                            height: 48,
                                            padding: 0,
                                            marginTop: 16
                                          }}
                                          color="secondary"
                                          text="Проверить тестовый заказ"
                                        />
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                  {state.bitrix.cid ? (
                                    <AccountIdentifierIcon
                                      className={classes.chanelStatusIcon}
                                    />
                                  ) : (
                                    <div>
                                      {!state.bitrix.data ? (
                                        ''
                                      ) : (
                                        <AccountAlertIcon
                                          className={classes.chanelStatusIcon}
                                        />
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    ) : (
                      ''
                    )}

                    {state.yclients.settings ? (
                      <a
                        href="/crm/yclients"
                        style={{
                          color: '#000',
                        }}
                      >
                        <div>
                          <div className={classes.crmWrapper}>
                            <div className={classes.existedCrmBlock}>
                              <Pencile className={classes.penile} />
                              <img src="/images/crm/yclients/logo.png"></img>
                              <div className={classes.crmDescription}>
                                В Google Analytics из YCLIENTS передаются данные о
                                продажах
                              </div>
                              <div className={classes.crmStatisticBlock}>
                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Куда отправлять данные
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.yclients.settings &&
                                      state.yclients.settings.destination ==
                                      'ecom'
                                        ? 'Покупки в электронной торговле'
                                        : ''}

                                      {state.yclients.settings &&
                                      state.yclients.settings.destination ==
                                      'event'
                                        ? 'Создать цель "Успешные продажи"'
                                        : ''}
                                    </div>
                                  </div>
                                </div>

                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Логин
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.yclients.settings.login}
                                    </div>
                                  </div>
                                </div>

                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Филиалы
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.yclients.statuses &&
                                      state.yclients.statuses.map(source => {
                                        return source.label + ' '
                                      })}
                                    </div>
                                  </div>
                                </div>

                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Последняя отправка данных
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.yclients.data &&
                                      (!state.yclients.error ||
                                        !state.yclients.error.text)
                                        ? state.yclients.data.updated_at
                                        : ''}
                                    </div>
                                    {state.yclients.error && state.yclients.error.text ? (
                                      <div className={classes.errors}>
                                        {state.yclients.error.text}
                                        {state.yclients.error.date ? (
                                          <span>
                                            <br />
                                            Данные не выгружаются с:{' '}
                                            {state.yclients.error.date}
                                          </span>
                                        ) : (
                                          ''
                                        )}
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                    {!state.yclients.data &&
                                    (!state.yclients.error ||
                                      !state.yclients.error.text) ? (
                                      <div className={classes.statisticData}>
                                        Данные по продажам пока не поступали
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                  {state.yclients.data &&
                                  (!state.yclients.error ||
                                    !state.yclients.error.text) ? (
                                    <AccountIdentifierIcon
                                      className={classes.chanelStatusIcon}
                                    />
                                  ) : (
                                    <div>
                                      {!state.yclients.data ? (
                                        ''
                                      ) : (
                                        <AccountAlertIcon
                                          className={classes.chanelStatusIcon}
                                        />
                                      )}
                                    </div>
                                  )}
                                </div>
                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Передача client_id
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.yclients.cid ? 'Все в порядке.' : ''}
                                    </div>
                                    {state.yclients.cid ? (
                                      ''
                                    ) : (
                                      <div>
                                        {!state.yclients.data ? (
                                          <div
                                            className={classes.statisticData}
                                          >
                                            Данные по продажам пока не поступали
                                          </div>
                                        ) : (
                                          <div className={classes.errors}>
                                            client_id не найден
                                            <br />
                                            Убедитесь, что в поле комментарий
                                            сделки передается значение Google
                                            client id.
                                            <br />
                                          </div>
                                        )}
                                      </div>
                                    )}

                                  </div>
                                  {state.yclients.cid ? (
                                    <AccountIdentifierIcon
                                      className={classes.chanelStatusIcon}
                                    />
                                  ) : (
                                    <div>
                                      {!state.yclients.data ? (
                                        ''
                                      ) : (
                                        <AccountAlertIcon
                                          className={classes.chanelStatusIcon}
                                        />
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    ) : (
                      ''
                    )}

                    {state.uon.settings ? (
                      <a
                        href="/crm/uon"
                        style={{
                          color: '#000',
                        }}
                      >
                        <div>
                          <div className={classes.crmWrapper}>
                            <div className={classes.existedCrmBlock}>
                              <Pencile className={classes.penile} />
                              <UonCrmBigIcon height={22} />
                              <div className={classes.crmDescription}>
                                В Google Analytics из U-ON передаются данные о
                                продажах
                              </div>
                              <div className={classes.crmStatisticBlock}>
                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Куда отправлять данные
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.uon.settings &&
                                      state.uon.settings.import_destination ==
                                        'ecom'
                                        ? 'Покупки в электронной торговле'
                                        : ''}

                                      {state.uon.settings &&
                                      state.uon.settings.import_destination ==
                                        'event'
                                        ? 'Создать цель "Успешные продажи"'
                                        : ''}
                                    </div>
                                  </div>
                                </div>

                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Выбранные статусы сделок
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.uon.statuses}
                                    </div>
                                  </div>
                                </div>

                                {state.uon.settings.import_destination ==
                                'ecom' ? (
                                  <div className={classes.crmStatisticWrapper}>
                                    <div className={classes.crmStatistic}>
                                      <div className={classes.statisticTitle}>
                                        Выбранный статус возврата
                                      </div>
                                      <div className={classes.statisticData}>
                                        {state.uon.settings.cancel_status}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  ''
                                )}

                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Последняя отправка данных
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.uon.data &&
                                      (!state.uon.error ||
                                        !state.uon.error.text)
                                        ? state.uon.data.updated_at
                                        : ''}
                                    </div>
                                    {state.uon.error && state.uon.error.text ? (
                                      <div className={classes.errors}>
                                        {state.uon.error.text}
                                        {state.uon.error.date ? (
                                          <span>
                                            <br />
                                            Данные не выгружаются с:{' '}
                                            {state.uon.error.date}
                                          </span>
                                        ) : (
                                          ''
                                        )}
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                    {!state.uon.data &&
                                    (!state.uon.error ||
                                      !state.uon.error.text) ? (
                                      <div className={classes.statisticData}>
                                        Данные по продажам пока не поступали
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                  {state.uon.data &&
                                  (!state.uon.error ||
                                    !state.uon.error.text) ? (
                                    <AccountIdentifierIcon
                                      className={classes.chanelStatusIcon}
                                    />
                                  ) : (
                                    <div>
                                      {!state.uon.data ? (
                                        ''
                                      ) : (
                                        <AccountAlertIcon
                                          className={classes.chanelStatusIcon}
                                        />
                                      )}
                                    </div>
                                  )}
                                </div>
                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Передача client_id
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.uon.cid ? 'Все в порядке.' : ''}
                                    </div>
                                    {state.uon.cid ? (
                                      ''
                                    ) : (
                                      <div>
                                        {!state.uon.data ? (
                                          <div
                                            className={classes.statisticData}
                                          >
                                            Данные по продажам пока не поступали
                                          </div>
                                        ) : (
                                          <div className={classes.errors}>
                                            client_id не найден
                                            <br />
                                            Убедитесь, что в поле комментарий
                                            сделки передается значение Google
                                            client id.
                                            <br />
                                          </div>
                                        )}
                                      </div>
                                    )}
                                    {!state.uon.haveLead ? (
                                      <div className={classes.noLeads}>
                                        {state.uon.statuses &&
                                        state.uon.statuses.length > 1 ? (
                                          <div>
                                            Пожалуйста, создайте тестовую сделку
                                            и переведите ее в любой из статусов{' '}
                                            {'{' + state.uon.statuses + '}'}.
                                            Проверка пройдет в течение одной
                                            минуты.
                                          </div>
                                        ) : (
                                          <div>
                                            Пожалуйста, создайте тестовую сделку
                                            и переведите ее статус{' '}
                                            {'{' + state.uon.statuses + '}'}.
                                            Проверка пройдет в течение одной
                                            минуты.
                                          </div>
                                        )}
                                        <ButtonOutlined
                                          handleClick={this.handleReload}
                                          style={{
                                            width: '100%',
                                            height: 48,
                                            padding: 0,
                                            marginTop: 16
                                          }}
                                          color="secondary"
                                          text="Проверить тестовый заказ"
                                        />
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                  {state.uon.cid ? (
                                    <AccountIdentifierIcon
                                      className={classes.chanelStatusIcon}
                                    />
                                  ) : (
                                    <div>
                                      {!state.uon.data ? (
                                        ''
                                      ) : (
                                        <AccountAlertIcon
                                          className={classes.chanelStatusIcon}
                                        />
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    ) : (
                      ''
                    )}

                    {state.getcourse.settings ? (
                      <a
                        href="/getcourse/connect/form"
                        style={{
                          color: '#000',
                        }}
                      >
                        <div>
                          <div className={classes.crmWrapper}>
                            <div className={classes.existedCrmBlock}>
                              <Pencile className={classes.penile} />
                              <GetCourseBigIcon height={22} />
                              <div className={classes.crmDescription}>
                                В Google Analytics из GetCource передаются данные о
                                продажах
                              </div>
                              <div className={classes.crmStatisticBlock}>
                                <div className={classes.crmStatisticWrapper}>

                                </div>


                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Последняя отправка данных
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.getcourse.data &&
                                      (!state.getcourse.error ||
                                        !state.getcourse.error.text)
                                        ? state.getcourse.data.updated_at
                                        : ''}
                                    </div>
                                    {state.getcourse.error && state.getcourse.error.text ? (
                                      <div className={classes.errors}>
                                        {state.getcourse.error.text}
                                        {state.getcourse.error.date ? (
                                          <span>
                                            <br />
                                            Данные не выгружаются с:{' '}
                                            {state.getcourse.error.date}
                                          </span>
                                        ) : (
                                          ''
                                        )}
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                    {!state.getcourse.data &&
                                    (!state.getcourse.error ||
                                      !state.getcourse.error.text) ? (
                                      <div className={classes.statisticData}>
                                        Данные по продажам пока не поступали
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                  {state.getcourse.data &&
                                  (!state.getcourse.error ||
                                    !state.getcourse.error.text) ? (
                                    <AccountIdentifierIcon
                                      className={classes.chanelStatusIcon}
                                    />
                                  ) : (
                                    <div>
                                      {!state.getcourse.data ? (
                                        ''
                                      ) : (
                                        <AccountAlertIcon
                                          className={classes.chanelStatusIcon}
                                        />
                                      )}
                                    </div>
                                  )}
                                </div>
                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Данные подключения
                                    </div>
                                    <div className={classes.statisticData}>
                                      Токен: {state.getcourse.settings.hash}
                                    </div>
                                  </div>
                                </div>
                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Поле CID
                                    </div>
                                    <div className={classes.statisticData}>
                                      cid
                                    </div>
                                  </div>
                                </div>
                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Передача client_id
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.getcourse.cid ? 'Все в порядке.' : ''}
                                    </div>
                                    {state.getcourse.cid ? (
                                      ''
                                    ) : (
                                      <div>
                                        {!state.getcourse.data ? (
                                          <div
                                            className={classes.statisticData}
                                          >
                                            Данные по продажам пока не поступали
                                          </div>
                                        ) : (
                                          <div className={classes.errors}>
                                            client_id не найден
                                            <br />
                                            Убедитесь, что в поле комментарий
                                            сделки передается значение Google
                                            client id.
                                            <br />
                                          </div>
                                        )}
                                      </div>
                                    )}
                                    {!state.getcourse.haveLead ? (
                                      <div className={classes.noLeads}>
                                        {state.getcourse.statuses &&
                                        state.getcourse.statuses.length > 1 ? (
                                          <div>
                                            Пожалуйста, создайте тестовую сделку
                                            и переведите ее в любой из статусов
                                            выбранных статусов сделок. Проверка
                                            пройдет в течение одной минуты.
                                          </div>
                                        ) : (
                                          <div>
                                            Пожалуйста, создайте тестовую сделку
                                            и переведите ее в любой из статусов
                                            выбранных статусов сделок. Проверка
                                            пройдет в течение одной минуты.
                                          </div>
                                        )}
                                        <ButtonOutlined
                                          handleClick={this.handleReload}
                                          style={{
                                            width: '100%',
                                            height: 48,
                                            padding: 0,
                                            marginTop: 16
                                          }}
                                          color="secondary"
                                          text="Проверить тестовый заказ"
                                        />
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                  {state.getcourse.cid ? (
                                    <AccountIdentifierIcon
                                      className={classes.chanelStatusIcon}
                                    />
                                  ) : (
                                    <div>
                                      {!state.getcourse.data ? (
                                        ''
                                      ) : (
                                        <AccountAlertIcon
                                          className={classes.chanelStatusIcon}
                                        />
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    ) : (
                      ''
                    )}

                    {state.custom.settings ? (
                      <a
                        href="/crm/custom"
                        style={{
                          color: '#000',
                        }}
                      >
                        <div>
                          <div className={classes.crmWrapper}>
                            <div className={classes.existedCrmBlock}>
                              <CustomCrmBigIcon height={22} />
                              <div className={classes.crmDescription}>
                                В Google Analytics из CRM передаются данные о
                                продажах
                              </div>
                              <div className={classes.crmStatisticBlock}>
                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Название CRM: {state.custom.settings.name}
                                    </div>
                                    {state.custom.isAvailable ? (
                                      ''
                                    ) : (
                                      <div className={classes.errors}>
                                        Ошибка поключения а аккаунту. Проверьте
                                        правильность введенных учетных данный
                                      </div>
                                    )}
                                  </div>
                                  {state.custom.isAvailable ? (
                                    <AccountIdentifierIcon
                                      className={classes.chanelStatusIcon}
                                    />
                                  ) : (
                                    <AccountAlertIcon
                                      className={classes.chanelStatusIcon}
                                    />
                                  )}
                                </div>
                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Последняя отправка данных
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.custom.data &&
                                      (!state.custom.error ||
                                        !state.custom.error.text)
                                        ? state.custom.data.updated_at
                                        : ''}
                                    </div>
                                    {state.custom.error &&
                                    state.custom.error.text ? (
                                      <div className={classes.errors}>
                                        {state.custom.error.text}
                                        {state.custom.error.date ? (
                                          <span>
                                            <br />
                                            Данные не выгружаются с:{' '}
                                            {state.custom.error.date}
                                          </span>
                                        ) : (
                                          ''
                                        )}
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                    {!state.custom.data &&
                                    (!state.custom.error ||
                                      !state.custom.error.text) ? (
                                      <div className={classes.statisticData}>
                                        Данные по продажам пока не поступали
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                  {state.custom.data &&
                                  (!state.custom.error ||
                                    !state.custom.error.text) ? (
                                    <AccountIdentifierIcon
                                      className={classes.chanelStatusIcon}
                                    />
                                  ) : (
                                    <div>
                                      {!state.custom.data ? (
                                        ''
                                      ) : (
                                        <AccountAlertIcon
                                          className={classes.chanelStatusIcon}
                                        />
                                      )}
                                    </div>
                                  )}
                                </div>
                                <div className={classes.crmStatisticWrapper}>
                                  <div className={classes.crmStatistic}>
                                    <div className={classes.statisticTitle}>
                                      Передача client_id
                                    </div>
                                    <div className={classes.statisticData}>
                                      {state.custom.cid ? 'Все в порядке.' : ''}
                                    </div>
                                    {state.custom.cid ? (
                                      ''
                                    ) : (
                                      <div>
                                        {!state.custom.data ? (
                                          <div
                                            className={classes.statisticData}
                                          >
                                            Данные по продажам пока не поступали
                                          </div>
                                        ) : (
                                          <div className={classes.errors}>
                                            client_id не найден
                                            <br />
                                            Убедитесь, что создано
                                            дополнительное поле "cid" и оно
                                            заполнено. Это поле должно содержать
                                            client_id пользователя из Google
                                            Analytics.
                                            <br />
                                          </div>
                                        )}
                                      </div>
                                    )}
                                    {!state.custom.haveLead ? (
                                      <div className={classes.noLeads}>
                                        <div>
                                          Пожалуйста, создайте тестовую сделку и
                                          переведите ее статус {'{purchase}'}.
                                          Проверка пройдет в течение одной
                                          минуты.
                                        </div>
                                        <ButtonOutlined
                                          handleClick={this.handleReload}
                                          style={{
                                            width: '100%',
                                            height: 48,
                                            padding: 0,
                                            marginTop: 16
                                          }}
                                          color="secondary"
                                          text="Проверить тестовый заказ"
                                        />
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                  {state.custom.cid ? (
                                    <AccountIdentifierIcon
                                      className={classes.chanelStatusIcon}
                                    />
                                  ) : (
                                    <div>
                                      {!state.custom.data ? (
                                        ''
                                      ) : (
                                        <AccountAlertIcon
                                          className={classes.chanelStatusIcon}
                                        />
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    ) : (
                      ''
                    )}
                  </div>
                ) : (
                  ''
                )}

                <div className={classes.crmList}>
                  {state.amoCrm.settings ? (
                    ''
                  ) : (
                    <div className={classes.crmBlock}>
                      <AmoCrmBigIcon width={150} height={33} />
                      <a href="/crm/amo" className={classes.crmButton}>
                        Подключить
                      </a>
                    </div>
                  )}
                  {state.bitrix24.settings ? (
                    ''
                  ) : (
                    <div className={classes.crmBlock}>
                      <Bitrix24BigIcon width={150} height={33} />
                      <a href="/crm/bitrix24" className={classes.crmButton}>
                        Подключить
                      </a>
                    </div>
                  )}
                  {state.retailCrm.settings ? (
                    ''
                  ) : (
                    <div className={classes.crmBlock}>
                      <RetailCrmBigIcon width={150} height={33} />
                      <a href="/crm/retail" className={classes.crmButton}>
                        Подключить
                      </a>
                    </div>
                  )}
                  {state.bitrix.settings ? (
                    ''
                  ) : (
                    <div className={classes.crmBlock}>
                      <BitrixBigIcon width={150} height={33} />
                      <a href="/crm/bitrix" className={classes.crmButton}>
                        Подключить
                      </a>
                    </div>
                  )}
                  {state.envyCrm.settings ? (
                    ''
                  ) : (
                    <div className={classes.crmBlock}>
                      <EnvyCrmBigIcon height={33} />
                      <a href="/crm/envy" className={classes.crmButton}>
                        Подключить
                      </a>
                    </div>
                  )}
                  {state.uon.settings ? (
                    ''
                  ) : (
                    <div className={classes.crmBlock}>
                      <UonCrmBigIcon height={33} />
                      <a href="/crm/uon" className={classes.crmButton}>
                        Подключить
                      </a>
                    </div>
                  )}
                  {state.megaplan.settings ? (
                    ''
                  ) : (
                    <div className={classes.crmBlock}>
                      <MegaplanIcon height={28} />
                      <a href="/crm/megaplan" className={classes.crmButton}>
                        Подключить
                      </a>
                    </div>
                  )}
                  {state.yclients.settings ? (
                    ''
                  ) : (
                    <div className={classes.crmBlock}>
                      <img src="/images/crm/yclients/logo.png"></img>
                      <a href="/crm/yclients" className={classes.crmButton}>
                        Подключить
                      </a>
                    </div>
                  )}
                  {state.custom.settings ? (
                    ''
                  ) : (
                    <div className={classes.crmBlock}>
                      <CustomCrmBigIcon height={33} />
                      <a href="/crm/custom" className={classes.crmButton}>
                        Подключить
                      </a>
                    </div>
                  )}
                  {state.getcourse.settings ? (
                    ''
                  ) : (
                    <div className={classes.crmBlock}>
                      <GetCourseBigIcon height={33} />
                      <a href="/getcourse/connect/form" className={classes.crmButton}>
                        Подключить
                      </a>
                    </div>
                  )}
                  <div className={classes.crmBlock}>
                    <div className={classes.newCrm}>
                      <b>В списке нет вашей CRM?</b>
                      Оставьте заявку.
                    </div>
                    <a
                      href="#"
                      className={classes.crmButtonNew}
                      onClick={this.handleClickOpen}
                    >
                      Заявка
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <Dialog
              fullScreen
              open={openModal}
              onClose={this.handleClose}
              TransitionComponent={Transition}
              PaperProps={{
                classes: {
                  root: this.props.classes.paper,
                },
              }}
            >
              <AppBar className={this.props.classes.appBar} elevation={0}>
                <Toolbar style={{ paddingTop: 16 }}>
                  {/* <LogoHelpData /> */}
                  <IconButton
                    color="inherit"
                    onClick={this.handleClose}
                    aria-label="Close"
                    style={{ marginLeft: 'auto' }}
                  >
                    <CloseIcon style={{ fill: '#fff' }} />
                  </IconButton>
                </Toolbar>
              </AppBar>
              <div
                style={{
                  maxWidth: 400,
                  width: '100%',
                  margin: '0 auto',
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <header className={classes.modalTitle}>
                  {/* <DishIcon width={48} height={32} className={classes.modalIcon} /> */}
                  <h6
                    style={{
                      fontFamily: 'Roboto',
                      fontSize: 24,
                      fontWeight: 'bold',
                      fontStyle: 'normal',
                      fontStretch: 'normal',
                      lineHeight: 'normal',
                      letterSpacing: 'normal',
                      textAlign: 'center',
                      color: 'rgb(0, 0, 0)',
                      margin: '0 0 24px 0',
                    }}
                  >
                    Напишите нам!
                  </h6>
                  <div className={classes.subTitle}>
                    {`Какую CRM вы используете?`}
                  </div>
                </header>
                <Wrapper
                  shadow={1}
                  style={{
                    width: '100%',
                    borderRadius: 8,
                    overflow: 'hidden',
                    padding: '40px 50px 50px 50px',
                    backgroundColor: 'rgb(255, 255, 255)',
                    fontFamily: '"Exo 2", "Helvetica", "Arial", sans-serif',
                    lineHeight: 1.5,
                  }}
                >
                  <CrmApplicationForm
                    onSubmit={this.handleSubmit}
                    isFetching={this.state.isFetching}
                    // initialValues={{ email: user.email, phone: user.phone }}
                  />
                </Wrapper>
              </div>
            </Dialog>

            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              open={openSnakbar}
              autoHideDuration={5000}
              onClose={this.handleCloseSnakbar}
              ContentProps={{
                'aria-describedby': 'message-id',
              }}
              message={<span id="message-id">Заявка отправлена!</span>}
              action={[
                <IconButton
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  className={classes.close}
                  onClick={this.handleCloseSnakbar}
                >
                  <CloseIcon />
                </IconButton>,
              ]}
            />
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withStyles(styles)(Crm)
